import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import {
  FeatureCheckboxSelected,
  FeatureCheckboxUnselected,
  InfoIcon,
  PriceIcon,
} from '../../../shared/svg/components';
import { changeIsDescriptionOpened } from '../../../model/configuratorSlice';
import { getFeaturePriceText, getPriceText } from '../../../utils/currencyFormatter';

const FeatureItemMobile = ({
  feature,
  categoryId,
  categoryType,
  isSelected,
  disabled,
  onFeatureSelected,
}) => {
  const { settings, currentUnit } = useSelector(state => state.configurator);
  const dispatch = useDispatch();

  return (
    <div className="feature-item-mobile">
      <div className="feature-title-container">
        <div className="feature-title">Opción {feature.order}</div>
        {feature.description !== null && feature.description.length > 0 && (
          <button
            className="info-button"
            type="button"
            onClick={() => dispatch(changeIsDescriptionOpened({ isOpen: true, featureId: feature.id, categoryId }))}
          >
            <InfoIcon className="icon" />
          </button>
        )}
        <div className="price">{getFeaturePriceText(feature, currentUnit)}</div>
      </div>
      <div className="container-button-name">
        <button
          type="button"
          disabled={disabled}
          onClick={() => onFeatureSelected((feature.id))}
          className="feature-thumb"
        >
          <div className="image-mask">
            <div className="image-container">
              <img src={`${settings.thumbs_base_url}/${feature.thumb}`} alt="" />
            </div>
            {isSelected
              ? <FeatureCheckboxSelected className="check" />
              : <FeatureCheckboxUnselected className="check" />}
          </div>
        </button>
        <div className="feature-name">{feature.name}</div>
      </div>

    </div>
  );
};

FeatureItemMobile.propTypes = {
  feature: (PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    description: PropTypes.string,
    thumb: PropTypes.string,
    order: PropTypes.number,
    price: PropTypes.string,
  })).isRequired,
  categoryId: PropTypes.string.isRequired,
  categoryType: PropTypes.string.isRequired,
  isSelected: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  onFeatureSelected: PropTypes.func.isRequired,
};

export default FeatureItemMobile;
